export default __webpack_public_path__ + "static/media/decor.0e9503f9.svg";